import { render, staticRenderFns } from "./ListApproval.vue?vue&type=template&id=389393e1&scoped=true&"
import script from "./ListApproval.vue?vue&type=script&lang=js&"
export * from "./ListApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389393e1",
  null
  
)

export default component.exports